import React from "react";
import styles from "./LandingPage3.module.scss";
import spak from "../../../Components/assets/Images/spark.svg";
import image1 from "../../../Components/assets/Images/nripage3image1.svg";
import image2 from "../../../Components/assets/Images/nripage3image2.svg";
import image3 from "../../../Components/assets/Images/nripage3image3.svg";
import startedarrow from "../../../Components/assets/Images/startedarrow.svg";
import support from "../../../Components/assets/Images/supportImage.svg";
import { LoadingButton } from "@mui/lab";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import c1Icon from "../../../Components/assets/Images/c1Icon.svg";
import c2Icon from "../../../Components/assets/Images/c2Icon.svg";
import c3Icon from "../../../Components/assets/Images/c3Icon.svg";
import c4Icon from "../../../Components/assets/Images/c4Icon.svg";
import c5Icon from "../../../Components/assets/Images/c5Icon.svg";
import c6Icon from "../../../Components/assets/Images/c6Icon.svg";
import whyChooseBg from "../../../Components/assets/Images/why-choose-new.svg";

const cardData = [
  {
    icon: c1Icon,
    text1: "Effortless Account Opening",
    text2:
      "We’ve made account opening simple and digital. Get started in minutes — no branch visits, paperwork, or complex forms to slow you down.",
  },
  {
    icon: c2Icon,
    text1: "Data Privacy Protection",
    text2:
      "Your data stays safe with us. We use advanced encryption and follow strict global standards to protect your privacy at every step.",
  },
  {
    icon: c3Icon,
    text1: "Secure Document Verification",
    text2:
      "Your data stays safe with us. We use advanced encryption and follow strict global standards to protect your privacy at every step.",
  },
  {
    icon: c4Icon,
    text1: "User-Friendly Interface",
    text2:
      "Our platform is simple, modern, and easy to navigate. Whether you're new or experienced, everything you need is just a tap or click away.",
  },
  {
    icon: c5Icon,
    text1: "Regulatory Compliance",
    text2:
      "We follow SEBI guidelines and meet all NRI compliance standards. Your investments stay secure, legal, and aligned with every regulation.",
  },
  {
    icon: c6Icon,
    text1: "Single Sign On",
    text2:
      "Use one secure login for all Firstock platforms. No need to remember multiple passwords or switch between apps.",
  },
];

export default function LandingPage3() {
  const navigate = useNavigate();
  return (
    <section className={styles.cardSection}>
      <div className={styles.mainWrapper}>
        <div className={styles.titleContainer}>
          <div className={styles.titleText}>
            Seamlessly Navigate Your NRI Onboarding Journey
          </div>
          <div className={styles.descText}>
            Investing in the stock market should be easy. That's why we created
            Firstock - a smarter way to invest, built around you.
          </div>
        </div>

        <div className={styles.cardWrapper}>
          <div className={styles.bgImage}>
            <img src={whyChooseBg} alt="" className={styles.image} />
          </div>
          {cardData.map((item: any, index: any) => (
            <>
              <div className={styles.card} key={index}>
                <div className={styles.iconwrap}>
                  <img src={item.icon} alt="" />
                </div>
                <div className={styles.text1}>{item.text1}</div>
                <div className={styles.text2}>{item.text2}</div>
              </div>
            </>
          ))}
        </div>

        <div className={styles.buttonSection}>
          <div
            className={styles.getStartedButton}
            onClick={() => {
              navigate("/email");
            }}
          >
            Get Started{" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M9.33333 3.33594L14 8.0026M14 8.0026L9.33333 12.6693M14 8.0026L2 8.0026"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
}
